import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { HiCheck, HiX } from 'react-icons/hi'
import { STEPS_STATUS } from '../utils/constant'

const { COMPLETE, PENDING, IN_PROGRESS, ERROR } = STEPS_STATUS

const STEP_STATUS_ICON = {
    [COMPLETE]: <HiCheck />,
    [PENDING]: null,
    [IN_PROGRESS]: null,
    [ERROR]: <HiX />
}

const CustomStepItem = forwardRef((props, ref) => {

    const {
        className,
        status,
        stepNumber,
        description,
        title,
        isLast,
        onStepChange,
        ...rest
    } = props


    const color = `green-600`

    let stepIcon = (
        <span>
            {STEP_STATUS_ICON[status] ?? stepNumber}
        </span>
    )

    const stepItemClass = classNames(
        `custom-step-item custom-step-item-${status}`,
        onStepChange && 'cursor-pointer',
        className
    )

    const stepIconClass = classNames(
        `custom-step-item-icon custom-step-item-icon-${status}`,
        status === COMPLETE && `bg-${color} text-white`,
        status === ERROR && `custom-step-item-icon-error`,
        status === IN_PROGRESS && `text-black dark:text-white border-${color} custom-step-item-icon-current`
    )

    const stepConnectClass = classNames(
        'custom-step-connect',
        status === COMPLETE ? `bg-${color}` : `inactive`
    )

    const stepTitleClass = classNames(
        'custom-step-item-title',
        status === ERROR && `custom-step-item-title-error`,
    )

    const stepDescriptionClass = classNames(
        'custom-step-item-desc',
    )

    return (
        <>
            <div
                ref={ref}
                className={stepItemClass}
                onClick={onStepChange}
                role={onStepChange ? "button" : undefined}
            >
                <div className={stepIconClass}>{stepIcon}</div>
                <div>
                    <div className="flex flex-col">
                        <p className={stepTitleClass}>{title}</p>
                        <p className={stepDescriptionClass}>{description}</p>
                    </div>
                </div>
            </div>
            {!isLast && <div className={stepConnectClass}></div>}
        </>
    )
})

CustomStepItem.propTypes = {
    vertical: PropTypes.bool,
    stepNumber: PropTypes.number,
    status: PropTypes.oneOf([COMPLETE, PENDING, IN_PROGRESS, ERROR]),
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]),
    description: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]),
    customIcon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]),
    isLast: PropTypes.bool,
}

export default CustomStepItem
